module.exports = __webpack_public_path__ + "img/image00006.ba27664c.jpeg";